import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import { type StepKey } from "@/react/types/Checklist";
import { Typography } from "@circle-react-uikit/Typography";
import { useMarkCompleteAction } from "./useMarkCompleteAction";

interface MarkCompleteButtonProps {
  stepKey: StepKey;
}

export const MarkCompleteButton = ({ stepKey }: MarkCompleteButtonProps) => {
  const { markComplete, isLoading } = useMarkCompleteAction(stepKey);

  return (
    <button
      type="button"
      className="flex flex-row items-center gap-x-1"
      onClick={markComplete}
      disabled={isLoading}
      aria-label={t(
        "community_onboarding.new_checklist.setup_checklist.mark_complete",
      )}
    >
      <Icon type={isLoading ? "loader" : "check"} size={16} />
      <Typography.LabelXs weight="medium" size="text-xs" color="text-default">
        {t("community_onboarding.new_checklist.setup_checklist.mark_complete")}
      </Typography.LabelXs>
    </button>
  );
};
